import type { FormEventHandler, FunctionComponent } from "react";

interface FormPreventDefaultProps {
  onSubmit: FormEventHandler;
  children?: React.ReactNode;
}

export const FormPreventDefault: FunctionComponent<FormPreventDefaultProps> = ({
  children,
  onSubmit,
}) => {
  function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    onSubmit(event);
  }
  return <form onSubmit={handleSubmit}>{children}</form>;
};
